import React, { useRef } from 'react';
import { useTranslation } from 'next-i18next';
import { useTemporaryBooleanState } from '@/hooks';
import { CheckSmallIcon, DownloadIcon, SquareStackIcon } from '@/icons';
import { Button } from '@/ui_v3';
import { cn } from '@/utils';
import { QRCodeBox } from './QRCodeBox';
export interface QRCodeSectionProps {
  url: string;
  onDownload: (qrCode: HTMLDivElement) => void;
  onCopy: (qrCode: HTMLDivElement, onSuccess?: () => void) => void;
}
export const DesktopQRCodeSection: React.FC<QRCodeSectionProps> = ({
  url,
  onDownload,
  onCopy
}) => {
  const {
    t
  } = useTranslation(['common']);
  const qrCodeRef = useRef<HTMLDivElement>(null);
  const [isQRCodeCopied, setIsQRCodeCopied] = useTemporaryBooleanState(false, 2000);
  return <QRCodeBox url={url} ref={qrCodeRef} data-sentry-element="QRCodeBox" data-sentry-component="DesktopQRCodeSection" data-sentry-source-file="DesktopQRCodeSection.tsx">
      <div className={cn('absolute inset-0 rounded-sm cursor-pointer transition duration-100 flex justify-center items-center', isQRCodeCopied ? 'bg-opacity-black-4' : 'group-hover:bg-opacity-black-4 bg-transparent')}>
        <div className={cn('flex items-center justify-center gap-[6px] transition duration-100', isQRCodeCopied ? 'opacity-100' : 'group-hover:opacity-100 opacity-0')}>
          <Button intent="alternative" leftSlot={<DownloadIcon />} className="rounded-full shadow-sm" onClick={() => {
          if (qrCodeRef.current) {
            onDownload(qrCodeRef.current);
          }
        }} data-sentry-element="Button" data-sentry-source-file="DesktopQRCodeSection.tsx">
            <span>{t('global.download.button')}</span>
          </Button>
          <Button intent="strong" leftSlot={isQRCodeCopied ? <CheckSmallIcon /> : <SquareStackIcon />} className="rounded-full shadow-sm" onClick={() => {
          if (qrCodeRef.current) {
            onCopy(qrCodeRef.current, () => setIsQRCodeCopied(true));
          }
        }} data-sentry-element="Button" data-sentry-source-file="DesktopQRCodeSection.tsx">
            <span>
              {isQRCodeCopied ? t('global.complete.button') : t('global.copy.button')}
            </span>
          </Button>
        </div>
      </div>
    </QRCodeBox>;
};